// extracted by mini-css-extract-plugin
export default {"panel":"Modal_panel__-hbEz","background":"Modal_background__Ow3v5"};